import { render, staticRenderFns } from "./FreelancersCreateModal.vue?vue&type=template&id=639d915b&scoped=true"
import script from "./FreelancersCreateModal.vue?vue&type=script&lang=js"
export * from "./FreelancersCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639d915b",
  null
  
)

export default component.exports